/**
 * "Cookie notice seen" flag (SCRUM-1954): the banner's Accept writes `'true'`. It is NOT consent — no tag
 * reads it as one. Also read by `public/affiliates-sdk.min.js`, which draws its own banner while it is not `'true'`.
 */
export const LOCAL_STORAGE_COOKIES_ACCEPTED = 'npCookiesAccepted';

/** Encrypted user payload persisted by `auth-context` (AES ciphertext, not plaintext PII). */
export const LOCAL_STORAGE_USER = 'user';

/** Initialization vector paired with `LOCAL_STORAGE_USER` — useless without it, but always cleared together. */
export const LOCAL_STORAGE_IV = 'iv';
